import { useState, useEffect, type PropsWithChildren } from 'react';
import request from 'shared/lib/request';
import config from 'config';
import authStore from 'shared/auth/authStore';

/**
 * Bootstraps the client
 *
 * Will fetch client-config and then verify authentication
 * and then load all required resources before rendering App.js
 */
const AuthWrapper = (props: PropsWithChildren<unknown>) => {
  const [fetching, setFetching] = useState(true);

  useEffect(() => {
    async function getConfig() {
      const url = window.location.origin;
      request.init(config);
      // Fetch client-config and then update the config module
      await request
        .get(`${url}/foundation/client-config`)
        .then((response) => {
          const fetchedConfig = response.data as Record<string, unknown>;

          for (const key in fetchedConfig) {
            // ESLint issue for key: https://github.com/eslint/eslint/issues/12117
            if (Object.prototype.hasOwnProperty.call(fetchedConfig, key)) {
              (config as Record<string, unknown>)[key] = fetchedConfig[key];
            }
          }
          request.init(config);
          request.setToken(authStore.authToken as string);
          setFetching(false);
        })
        .catch(() => {
          setFetching(false);
        });
    }

    getConfig();
  }, []);

  if (fetching) {
    return <div>Authenticating...</div>;
  }

  return <>{props.children}</>;
};

export default AuthWrapper;
